import {
  Box,
  Button,
  Center,
  FiPlus,
  FiTrash2,
  useFieldArray,
  useFormContext,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import React from 'react';
import { EquityInfoDocument } from './EquityInfoDocument';
import { defaultValueShape } from './utils';

interface Props {
  name: string;
  isDocumentRequired?: boolean;
  label: string;
  handleRemove?: () => void;
  additionalLabel: string;
  hideDelete?: boolean;
  hideAddAdditional?: boolean;
  disabledActions?: boolean;
}

export const MultipleEquityInfoDocument = ({
  name,
  label,
  additionalLabel,
  hideDelete = false,
  hideAddAdditional = false,
  disabledActions = false,
}: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const {
    fields: fieldsArray,
    append: appendField,
    remove: removeField,
  } = useFieldArray({
    control: control,
    name,
  });

  return (
    <>
      {fieldsArray.map((field, index) => {
        const fieldPrefix = `${name}.${index}`;
        const isLastElement = fieldsArray.length - 1 === index;
        const isOnlyElement = fieldsArray.length === 1;
        const shouldShowAddField =
          (isLastElement || isOnlyElement) && !hideAddAdditional;
        const labelWithNumber = `${label} ${index > 0 ? index + 1 : ''}`;
        const shouldHideDelete = hideDelete;

        return (
          <Box key={field.id}>
            <EquityInfoDocument
              fieldPrefix={fieldPrefix}
              label={labelWithNumber}
              hideDelete={shouldHideDelete}
              deleteButton={
                shouldHideDelete ? null : (
                  <Button
                    fontSize="14px"
                    h="14px"
                    w={'14px !important'}
                    rightIcon={<FiTrash2 />}
                    onClick={() => {
                      removeField(index);
                      if (isOnlyElement) appendField(defaultValueShape);
                    }}
                    variant="linkDestructive"
                  >
                    {t('common.delete')}
                  </Button>
                )
              }
            />

            {shouldShowAddField ? (
              <Center w="full" mt={6}>
                <Button
                  onClick={() => appendField(defaultValueShape)}
                  variant="linkPrimary"
                  size="sm"
                  leftIcon={<FiPlus />}
                  isDisabled={disabledActions}
                >
                  {additionalLabel}
                </Button>
              </Center>
            ) : null}
          </Box>
        );
      })}
    </>
  );
};
